import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-unavailability-category__wrapper" }
const _hoisted_2 = { class: "b-form-recurrence" }
const _hoisted_3 = { class: "h-text-center h-mv-20" }
const _hoisted_4 = { class: "b-base-title h-mb-30" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeaturesSaveButton = _resolveComponent("FeaturesSaveButton")!
  const _component_FormMenuItem = _resolveComponent("FormMenuItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isSaveButtonShow)
      ? (_openBlock(), _createBlock(_component_FeaturesSaveButton, {
          key: 0,
          onClick: _ctx.setCategoryIndexHandler
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('BUTTON.CATEGORIES')), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (item, index) => {
        return (_openBlock(), _createBlock(_component_FormMenuItem, {
          key: index,
          class: "h-mv-10",
          title: _ctx.$t(item.title),
          isActive: index === _ctx.activeIndex,
          leftIcon: "label-icon",
          onClick: ($event: any) => (_ctx.setCategoryIndexHandler(index))
        }, null, 8, ["title", "isActive", "onClick"]))
      }), 128))
    ])
  ]))
}